(() => {
  'use strict';
  const drawer = document.querySelector('#steammy-cart');
  if (!drawer) return;
  const find = selector => drawer.querySelector(selector);
  const root = window.Shopify?.routes?.root || '/';
  const list = find('[data-cart-items]');
  const status = find('[data-cart-status]');
  const checkout = find('[data-cart-checkout]');
  const triggers = [...document.querySelectorAll('[data-cart-open]')];
  let cart = null, busy = false, revision = 0;
  const money = cents => new Intl.NumberFormat('fr-FR', {style:'currency',currency:cart?.currency || 'EUR'}).format(cents / 100);
  const element = (tag, cls, text) => {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  function message(text, error = false) {
    status.textContent = text;
    status.classList.toggle('cart-error', error);
  }
  function lock(value) {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    list.querySelectorAll('button,input').forEach(node => node.disabled = value);
    checkout.disabled = value || !cart?.item_count;
  }
  function show() {
    if (!drawer.open) drawer.showModal();
    document.body.classList.add('modal-open');
    triggers.forEach(node => node.setAttribute('aria-expanded', 'true'));
  }
  async function request(path, body) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(root + path, {
        method:body ? 'POST' : 'GET', credentials:'same-origin', cache:'no-store',
        headers:{Accept:'application/json', ...(body ? {'Content-Type':'application/json'} : {})},
        ...(body ? {body:JSON.stringify(body)} : {}), signal:controller.signal
      });
      const data = await response.json().catch(() => null);
      if (!response.ok) throw new Error(typeof data?.description === 'string' ? data.description : 'Le panier est momentanément indisponible. Réessayez dans un instant.');
      if (!data) throw new Error('Impossible de lire le panier. Réessayez dans un instant.');
      return data;
    } catch (error) {
      if (error.name === 'AbortError' || error instanceof TypeError) throw new Error('Connexion interrompue. Actualisez le panier pour vérifier votre sélection avant de réessayer.');
      throw error;
    } finally { clearTimeout(timer); }
  }
  function render(next) {
    cart = next;
    list.replaceChildren();
    const count = cart.item_count;
    const badge = document.querySelector('#bag-count');
    if (badge) badge.textContent = count;
    find('[data-cart-count]').textContent = `${count} article${count > 1 ? 's' : ''}`;
    find('[data-cart-empty]').hidden = count > 0;
    find('[data-cart-summary]').hidden = !count;
    find('[data-cart-offer]').hidden = !count;
    cart.items.forEach((item, index) => {
      const row = element('li', 'cart-item');
      row.dataset.cartLine = index;
      const imageUrl = item.featured_image?.url || item.image;
      if (imageUrl) {
        const image = element('img', 'cart-item-image');
        image.src = imageUrl; image.alt = item.product_title || item.title;
        image.width = 76; image.height = 90;
        row.append(image);
      }
      const info = element('div', 'cart-item-info');
      info.append(element('h3', '', item.product_title || item.title));
      if (item.variant_title && item.variant_title !== 'Default Title') info.append(element('p', 'cart-item-variant', item.variant_title));
      Object.entries(item.properties || {}).forEach(([key, value]) => {
        if (!key.startsWith('_') && value) info.append(element('p', 'cart-item-variant', `${key} : ${value}`));
      });
      const prices = element('div', 'cart-item-prices');
      prices.append(element('strong', '', money(item.final_line_price)));
      if (item.original_line_price > item.final_line_price) prices.append(element('del', '', money(item.original_line_price)));
      info.append(prices);
      const labels = [...new Set((item.line_level_discount_allocations || []).map(d => d.discount_application?.title).filter(Boolean))];
      if (labels.length) info.append(element('p', 'cart-item-discount', labels.join(' · ')));
      const controls = element('div', 'cart-item-controls');
      const quantity = element('div', 'cart-quantity');
      const label = `${item.product_title || item.title}${item.variant_title ? ', ' + item.variant_title : ''}`;
      function button(text, action, value) {
        const node = element('button', '', text);
        node.type = 'button'; node.dataset.cartAction = action;
        node.setAttribute('aria-label', `${action === 'minus' ? 'Diminuer la quantité' : 'Augmenter la quantité'} : ${label}`);
        node.addEventListener('click', () => change(item.key, value, index, action));
        return node;
      }
      const input = element('input');
      input.type = 'number'; input.min = '0'; input.step = '1'; input.value = item.quantity;
      input.setAttribute('aria-label', `Quantité : ${label}`); input.dataset.cartAction = 'quantity';
      input.addEventListener('change', () => {
        const value = Number(input.value);
        if (input.value === '' || !Number.isInteger(value) || value < 0) { input.value = item.quantity; return; }
        if (value !== item.quantity) change(item.key, value, index, 'quantity');
      });
      quantity.append(button('−', 'minus', item.quantity - 1), input, button('+', 'plus', item.quantity + 1));
      const remove = element('button', 'cart-remove', 'Retirer');
      remove.type = 'button'; remove.dataset.cartAction = 'remove';
      remove.setAttribute('aria-label', `Retirer : ${label}`);
      remove.addEventListener('click', () => change(item.key, 0, index, 'remove'));
      controls.append(quantity, remove); info.append(controls); row.append(info); list.append(row);
    });
    const savings = Math.max(0, cart.original_total_price - cart.total_price);
    find('[data-cart-savings-row]').hidden = !savings;
    find('[data-cart-savings]').textContent = '−' + money(savings);
    find('[data-cart-subtotal]').textContent = money(cart.original_total_price);
    find('[data-cart-total]').textContent = money(cart.total_price);
    checkout.textContent = 'Valider mon panier';
    lock(busy);
  }
  async function refresh(silent = false) {
    if (busy) return;
    const version = ++revision;
    if (!silent) { lock(true); message('Chargement de votre panier…'); }
    try {
      const next = await request('cart.js');
      if (version !== revision) return;
      render(next);
      if (!silent) message('');
    } catch (error) {
      if (version === revision && !silent) message(error.message, true);
    } finally { if (version === revision && !silent) lock(false); }
  }
  async function change(key, quantity, index, action) {
    if (busy) return;
    ++revision; lock(true); message('Mise à jour de votre panier…');
    try {
      render(await request('cart/change.js', {id:key, quantity}));
      message(quantity ? 'Panier mis à jour.' : 'Article retiré du panier.');
    } catch (error) { render(cart); message(error.message, true); }
    finally {
      lock(false);
      if (drawer.open) (list.querySelector(`[data-cart-line="${Math.min(index, cart.items.length - 1)}"] [data-cart-action="${action}"]`) || find('[data-cart-close]')).focus();
    }
  }
  async function add(items) {
    if (busy) throw new Error('Le panier se met à jour. Réessayez dans un instant.');
    ++revision; show(); lock(true); message('Ajout de votre sélection…');
    let added = false;
    try {
      await request('cart/add.js', {items}); added = true;
      render(await request('cart.js'));
      message('Votre sélection a été ajoutée au panier.');
    } catch (error) {
      if (added) {
        // A successful POST must never be repeated because its following GET failed.
        cart = null; list.replaceChildren(); find('[data-cart-summary]').hidden = true;
        find('[data-cart-empty]').hidden = true; find('[data-cart-offer]').hidden = true;
        message('Votre ajout est enregistré. Cliquez sur « Actualiser » pour afficher votre panier.', true);
      } else { message(error.message, true); throw error; }
    } finally { lock(false); }
  }
  triggers.forEach(node => {
    node.setAttribute('aria-controls', drawer.id); node.setAttribute('aria-haspopup', 'dialog'); node.setAttribute('aria-expanded', 'false');
    node.addEventListener('click', () => { show(); refresh(); });
  });
  drawer.querySelectorAll('[data-cart-close]').forEach(node => node.addEventListener('click', () => drawer.close()));
  drawer.addEventListener('click', event => {
    if (event.target !== drawer) return;
    const bounds = drawer.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) drawer.close();
  });
  drawer.addEventListener('close', () => {
    triggers.forEach(node => node.setAttribute('aria-expanded', 'false'));
    if (!document.querySelector('dialog[open]')) document.body.classList.remove('modal-open');
  });
  find('[data-cart-refresh]').addEventListener('click', () => refresh());
  find('[data-cart-form]').action = root + 'cart';
  find('[data-cart-form]').addEventListener('submit', event => { if (busy || !cart?.item_count) event.preventDefault(); });
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(!drawer.open); });
  window.SteammyCart = {add, open:() => { show(); return refresh(); }};
  refresh(true);
})();
